export default __webpack_public_path__ + "static/media/my.145010a9.svg";